import { ProductType } from '@common/enums';
import { CornerRadiusModel } from '@common/models';
import { COMING_SOON_IMAGE, convertProductsToProductDetailsList } from '@common/utils';

export const setDefaultCornerRadiusImage = (cornerRadius: CornerRadiusModel): CornerRadiusModel => {
    return cornerRadius.imageUrl ? cornerRadius : { ...cornerRadius, imageUrl: COMING_SOON_IMAGE };
};

export const convertCornerRadiiToProductDetails = convertProductsToProductDetailsList(ProductType.CORNER_RADIUS);
